<div class="sensor_threshold_popup" *ngIf="data.type === 'allMertrics'">
    <div class="modal-header">
      <h4 class="modal-title">Sensor Threshold Value</h4>
    </div>
  
    <div class="modal-body">
      <div class="table-responsive" style="max-height: 300px; overflow-y: auto">
        <table class="table">
          <thead>
            <tr>
              <th>Sensor Group</th>
              <th>Range</th>
              <th>Under-Red</th>
              <th>Under-Yellow</th>
              <th>Under-Green</th>
              <th>Over-Green</th>
              <th>Over-Yellow</th>
              <th>Over-Red</th>
              <th>Error Counter</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of data.dataAll |slice : 0:7; let i = index">
              <input
                      type="text"
                      [(ngModel)]="data.metric_label"
                      name="metric_label"
                      class="form-control"
                      (input)="updateData($event, i)"
                    />
              <td>
                <div class="flexnalign">
                  <div class="input-group width_70 m_r_10">
                    <input
                      type="number"
                      [(ngModel)]="data.base_value"
                      name="base_value"
                      [min]="0"
                      class="form-control"
                      placeholder="Min"
                      (input)="updateData($event, i)"
                    />
                  </div>
                  <div class="input-group width_70">
                    <input
                      type="number"
                      [(ngModel)]="data.max_value"
                      name="max_value"
                      class="form-control"
                      placeholder="Max"
                      (input)="updateData($event, i)"
                    />
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group width_100">
                  <input
                    type="number"
                    [(ngModel)]="data.threshold_1"
                    name="threshold_1"
                    min="1"
                    class="form-control"
                    (input)="updateData($event, i)"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="flexnalign">
                  <div class="input-group width_100">
                    <input
                      type="number"
                      [(ngModel)]="data.threshold_2"
                      name="threshold_2"
                     min="1"
                      class="form-control"
                      (input)="updateData($event, i)"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="input-group width_100">
                  <input
                    type="number"
                    [(ngModel)]="data.threshold_3"
                    class="form-control"
                    (input)="updateData($event, i)"
                    
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="input-group width_100">
                  <input
                    type="number"
                    [(ngModel)]="data.orieX_default"
                    class="form-control"
                    (input)="updateData($event, i)"
                    
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="input-group width_100">
                  <input
                    type="number"
                    [(ngModel)]="data.orieY_default"
                    class="form-control"
                    (input)="updateData($event, i)"
                    
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="input-group width_100">
                  <input
                    type="number"
                    [(ngModel)]="data.orieZ_default"
                    class="form-control"
                    (input)="updateData($event, i)"
                    disabled
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="input-group width_70">
                  <input
                    type="number"
                    name="counter"
                    min="0"
                    [(ngModel)]="data.max_counter"
                    class="form-control"
                    (input)="updateData($event, i)"
                  />
                </div>
              </td>
              <!-- <td class="text-center">
                <div class="input-group width_100">
                  <input
                    type="number"
                    name="counter"
                    min="0"
                    [(ngModel)]="data.max_counter"
                    class="form-control"
                    (input)="updateData($event, i)"
                  />
                </div>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
  
      <div class="container mt-2">
        <div class="card shadow-sm p-4">
          <h5 class="mb-1">Add Comment</h5>
          
          <div class="form-group mb-2">
            <label for="supervisor" class="form-label fw-bold">Supervisor Name</label>
            <input 
              type="text" 
              class="form-control" 
              id="supervisor" 
              placeholder="Enter Supervisor Name" 
              (input)="setSuperVisor($event)">
          </div>

          <div class="form-group mb-2">
            <label for="comment" class="form-label fw-bold">Comment</label>
            <textarea 
              class="form-control" 
              id="comment" 
              rows="2" 
              placeholder="Write your comment here..." 
              (input)="addComment($event)">
            </textarea>
          </div>

        </div>
      </div>
    <div class="modal-footer">
      <button mat-button class="btn primary_btn" (click)="saveMetricsData()" [disabled]="!saveButton">
        Save
      </button>
      <button mat-button class="btn default_btn" (click)="onClose()">
        Close
      </button>
    </div>
  </div>

  